export default {
  namespaced: true,
  state: {
    currentUser: null,
  },
  getters: {
    currentUser: (state) => state.currentUser,
  },
  mutations: {
    set(state, { type, items }) {
      state[type] = items;
    },
  },
  actions: {
    async setProfile({ commit }, params) {
      commit("set", {
        type: "currentUser",
        items: params,
      });
    },
  },
};
